import "core-js/modules/es.array.push.js";
export default {
  data() {},
  props: {
    plotId: {
      type: String,
      default: ""
    },
    number: {
      type: String,
      default: ""
    }
  },
  watch: {
    number(newVal, oldVal) {
      console.log(newVal, '值变了');
      this.getData(newVal);
    }
  },
  mounted() {
    // this.getPlotInfo(this.number)
    this.getPlotInfo(this.plotId);
  },
  methods: {
    // 获取地块详情
    async getPlotInfo(id) {
      let {
        code,
        data
      } = await this.$api.getPlotInfo(id);
      if (code == "200") {
        this.getData(data.greenhouseVoList[0].number);
        window.localStorage.setItem('plotInfo', JSON.stringify(data));
      }
      console.log(data, "地块信息");
    },
    // 获取历史数据
    async getData(number) {
      let params = {
        number
      };
      let {
        code,
        rows
      } = await this.$api.getGreenhouseListData(params);
      if (code == "200") {
        let xData = this.getChartsData(rows, "createTime");
        let yData = this.getChartsData(rows, "airTemperature");
        this.initChart(xData, yData);
      }
      console.log(rows, "环境监测历史数据");
    },
    // 获取不同字段，组成数组
    getChartsData(array, prop) {
      let arr = [];
      for (let i = 0; i < array.length; i++) {
        arr.push(array[i][prop]);
      }
      return arr;
    },
    initChart(xData, data1) {
      console.log("打印");
      var chartDom = document.querySelector("#plot-temperatureMonitoring-chart");
      // var chartDom = this.$refs.echarts;
      var myChart = this.$echarts.init(chartDom);
      // 配置项
      const option = {
        // 设置折线颜色和线条粗细
        color: ["#31f7ff"],
        grid: {
          top: "20%",
          // 顶部留白
          left: "10%",
          // 左侧留白
          right: "10%",
          // 右侧留白
          bottom: "20%" // 底部留白
        },

        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            color: "rgba(255, 255, 255, 1)",
            // x 轴刻度文字颜色
            formatter: function (value) {
              return value.split(' ')[1];
              // 格式化日期
              const date = new Date(value);
              const year = date.getFullYear();
              const month = date.getMonth() + 1;
              const day = date.getDate();
              return `${year}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day}`;
            }
          },
          splitLine: {
            show: true,
            // 显示竖线网格
            lineStyle: {
              color: "rgba(255, 255, 255, 1)" // 竖线网格颜色
            }
          }
        },

        yAxis: {
          type: "value",
          axisLabel: {
            color: "#ffffff" // x 轴刻度文字颜色
          },

          splitLine: {
            show: true,
            // 显示横线网格
            lineStyle: {
              color: "rgba(255, 255, 255, 1)" // 横线网格颜色
            }
          }
        },

        series: [{
          name: "温度",
          type: "line",
          smooth: true,
          symbol: "circle",
          // 拐点图形为圆形
          symbolSize: 6,
          // 拐点图形大小
          itemStyle: {
            color: "#2bb8ea" // 线条内小细线的颜色
          },

          lineStyle: {
            width: 3 // 折线粗细
          },

          data: data1,
          markPoint: {
            symbol: "circle",
            symbolSize: 8,
            itemStyle: {
              color: "rgba(82, 127, 255, 1)",
              // 拐点颜色
              borderColor: "#fff",
              // 圆心颜色
              borderWidth: 2
            }
          }
        }],
        // 设置图例
        legend: {
          top: 10,
          data: ["温度"],
          textStyle: {
            color: "#fff",
            // 设置文字颜色为白色
            fontSize: 10 // 设置文字大小为10px
          }
        }
      };

      option && myChart.setOption(option);
    }
  }
};